import { render, staticRenderFns } from "./DrugName.vue?vue&type=template&id=4be7e6f8&scoped=true&"
import script from "./DrugName.vue?vue&type=script&lang=ts&"
export * from "./DrugName.vue?vue&type=script&lang=ts&"
import style0 from "./DrugName.vue?vue&type=style&index=0&id=4be7e6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be7e6f8",
  null
  
)

export default component.exports